import { NgModule } from "@angular/core";
import { REBAR_AUTH_GUARD } from "./core/rebarauth/rebar.auth.module";
import { Routes, RouterModule } from "@angular/router";
import { Router } from "@angular/router";

// Routing related to Srinivas.
import { HomeComponent } from "./feature/home/home.component";
import { OnlineSupportComponent } from "./feature/home/online-support.component";
import { TermsAndConditionsComponent } from "./feature/home/terms-and-conditions.component";
import { GatewayComponent } from "./feature/config/gateway.component";
import { CallratesComponent } from "./feature/config/callrates.component";
import { CallrulesComponent } from "./feature/config/callrules.component";
import { ProjectComponent } from "./feature/config/project.component";
import { DeviceComponent } from "./feature/config/device.component";
import { TelcoComponent } from "./feature/config/telco.component";
import { DestinationComponent } from "./feature/config/destination.component";
import { CurrenconversionComponent } from "./feature/config/currenconversion.component";
import { CountryconfigurationComponent } from "./feature/config/countryconfiguration.component";
import { CommonareaphoneComponent } from "./feature/config/commonareaphone.component";
import { DailinconferenceComponent } from "./feature/config/dailinconference.component";
import { ShortCodeComponent } from "./feature/config/short-code.component";
import { AddAuthLevelComponent } from "./feature/config/add-auth-level.component";

// Routing related to Kumar
import { LeaversComponent } from "./feature/requisitationToPay/leavers.component";
import { RecoveryReportsComponent } from "./feature/reports/recovery-reports.component";
import { SummaryReportsComponent } from "./feature/reports/summary-reports.component";
import { RetaggingOfCallsComponent } from "./feature/requisitationToPay/retagging-of-calls.component";
import { SuggestionAndFeedbackComponent } from "./feature/help/suggestion-and-feedback.component";
import { LoginComponent } from "./feature/login/login.component";

// Routing related to Sridevi
import { UseraccessComponent } from "./feature/admin/useraccess.component";
import { MyprofileComponent } from "./feature/profile/myprofile/myprofile.component";
import { ActivateAuthcodeComponent } from "./feature/authcodedetails/activate-authcode.component";
import { DeactivateAuthcodeComponent } from "./feature/authcodedetails/deactivate-authcode/deactivate-authcode.component";
import { SuggestionsComponent } from "./feature/admin/suggestions.component";

// Routing related to Swatika
import { SourceComponent } from "./feature/config/source.component";
import { GroupaccessComponent } from "./feature/admin/groupaccess.component";
import { ManageaccessComponent } from "./feature/admin/manageaccess.component";
import { SchedulereportsComponent } from "./feature/config/schedulereports.component";
import { RecoveryreportsComponent } from "./feature/config/recoveryreports.component";
import { SummaryreportsComponent } from "./feature/config/summaryreports.component";

const routes: Routes = [
  // Routing related to Srinivas.

  { path: "", pathMatch: "full", redirectTo: "Home" },
  {
    path: "Home",
    component: HomeComponent,
    // canActivate: [
    //   REBAR_AUTH_GUARD,
    //   /* {
    //   path: 'home',
    //   loadChildren: './feature/home/home.module#HomeModule',
    //   canActivate: [REBAR_AUTH_GUARD]
    // }*/

    //   /* {
    //   path: 'home',
    //   loadChildren: './feature/home/home.module#HomeModule',
    //   canActivate: [REBAR_AUTH_GUARD]
    // }*/
    // ],
  },

  { path: "OnlineSupport", component: OnlineSupportComponent }, // canActivate: [REBAR_AUTH_GUARD ] },
  { path: "TermsConditions", component: TermsAndConditionsComponent }, // canActivate: [REBAR_AUTH_GUARD ] },
  { path: "Gateway", component: GatewayComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "CallRates", component: CallratesComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "CallRules", component: CallrulesComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "Project", component: ProjectComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "Device", component: DeviceComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "Telco", component: TelcoComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "Destination", component: DestinationComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "CurrencyConversion", component: CurrenconversionComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  {
    path: "CountryCodeConfiguration",
    component: CountryconfigurationComponent,
  }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "CAPMap", component: CommonareaphoneComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "DailInConference", component: DailinconferenceComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "ShortCode", component: ShortCodeComponent }, // canActivate: [REBAR_AUTH_GUARD]},
  { path: "AuthorizationLevel", component: AddAuthLevelComponent }, // canActivate: [REBAR_AUTH_GUARD]},

  // Routing related to Kumar
  { path: "Login", component: LoginComponent },
  { path: "SuggestionsFeedback", component: SuggestionAndFeedbackComponent },
  { path: "Reports", component: RecoveryReportsComponent },
  { path: "SummaryReports", component: SummaryReportsComponent },
  { path: "Leavers", component: LeaversComponent },
  { path: "RetaggingOfCalls", component: RetaggingOfCallsComponent },
  // Routing related to Sridevi
  { path: "UserAccess", component: UseraccessComponent },
  { path: "AdminFeedBkSuggtn", component: SuggestionsComponent },
  { path: "Profile", component: MyprofileComponent },
  { path: "ActivateAuthRequests", component: ActivateAuthcodeComponent },
  { path: "DeActivateAuthRequests", component: DeactivateAuthcodeComponent },
  // Routing related to swatika.
  { path: "Source", component: SourceComponent },
  { path: "GroupAccess", component: GroupaccessComponent },
  { path: "ManageAccess", component: ManageaccessComponent },
  { path: "SchedulerReports", component: SchedulereportsComponent },
  { path: "RecoverReportsScheduler", component: RecoveryreportsComponent },
  { path: "SummaryReportsScheduler", component: SummaryreportsComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
